require('./vendor/jquery.hoverIntent');
require('slick-carousel');
require('jquery-confirm');

require('./vendor/featherlight.min');
require('./vendor/featherlight.gallery');

import ImageViewer from 'iv-viewer';

require('./cookie.js');

var viewportWidth = window.innerWidth;

var allVideos;

require('./_navigation.js');

jQuery(document).ready(function ($) {

	viewportWidth = window.innerWidth;


	if ($(".map_element").length) {
		initMap();
	}

	$('.form_style :required').prev('label').addClass('required');
	
	// STYLED SELECT BOXES //
	$('.form_style select, .styled_select').each(function(){
		if (!$(this).parent().hasClass('select_wrapper')) {
			$(this).wrap('<div class="select_wrapper"></div>');
		}
	});

	$('#pagesize select').change(function () {
		$('#pagesize').submit();
	});

	// RESPONSIVE VIDEO
	allVideos = $("iframe[src^='https://www.youtube'], iframe[src^='//www.youtube'], iframe[src^='https://player.vimeo.com'], iframe[src^='//player.vimeo.com']");
	// Figure out and save aspect ratio for each video
	allVideos.each(function() {

		var the_width = $(this).width();
		var the_height = $(this).height();

			$(this)
			.attr('data-aspectratio', the_height / the_width)
			.attr('data-maxwidth', the_width)
			.attr('data-maxheight', the_height)
			.css('margin-bottom','calc(2vw + 2.0rem)')
			.css('max-width','100%');

	});
	fluidVideos();

	$('.video video').click(function () {
		if (this.paused) {
			$(this).parent().removeClass('paused').addClass('playing');
			this.play();
			this.addEventListener('ended', function () {
				$(this).parent().addClass('paused').removeClass('playing');
			},false);
    	} else {
			$(this).parent().addClass('paused').removeClass('playing');
			this.pause();
		}
	});

	$('.homepage_carousel .slides').slick({
		adaptiveHeight: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		swipe: false,
		draggable: false,
		fade: true,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 6000,
		speed: 1000,
		arrows: false,
		dots: true,
		cssEase: 'ease-in-out',
		rows: 0
	});

	$('.auction_highlights .lot_list').slick({
		adaptiveHeight: false,
		slidesToShow: 4,
		slidesToScroll: 1,
		swipeToSlide: true,
		swipe: true,
		draggable: true,
		fade: false,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 3000,
		speed: 1000,
		arrows: true,
		dots: false,
		cssEase: 'ease-in-out',
		rows: 0,
		appendArrows: $('.auction_highlights > div > h2'),
		prevArrow:"<button type='button' class='slick-prev'><i class='fal fa-chevron-left' aria-hidden='true'></i></button>",
		nextArrow: "<button type='button' class='slick-next'><i class='fal fa-chevron-right' aria-hidden='true'></i></button>",
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 601,
				settings: {
					slidesToShow: 2,
					arrows: false,
				}
			},
			{
				breakpoint: 375,
				settings: {
					slidesToShow: 1,
					arrows: false,
				}
			}
		]
	});

	$('.lot_carousel ul').on('init', function (event, slick) {
		$('.lot_thumbnails li.active').removeClass("active");
		$('.lot_thumbnails li').eq(0).addClass("active");
	}).slick({
		adaptiveHeight: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: false,
		infinite: true,
		autoplay: false,
		speed: 600,
		arrows: false,
		dots: false,
		cssEase: 'ease-in-out',
		rows: 0
	}).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
		$('.lot_thumbnails li.active').removeClass("active");
		$('.lot_thumbnails li').eq(nextSlide).addClass("active");
	});

	$('.lot_thumbnails li').click(function () {
		var index = $(this).index();
		$('.lot_carousel ul').slick('slickGoTo', index);
	});

	jconfirm.defaults = {
		draggable: false,
		useBootstrap: false,
		boxWidth: '50rem',
		type: 'blue',
		typeAnimated: false
	};


	var container;
	var viewer;

	$('.lot_carousel ul').featherlightGallery({
		filter: 'li:not(.slick-cloned)',
		targetAttr: 'data-src',
		afterContent: function (event) {

			if (typeof viewer !== "undefined") {
				viewer = viewer.destroy();
			}

			$('.featherlight-image').wrap("<div class='featherlight-image-wrapper'></div>");

			container = document.querySelector('.featherlight-image-wrapper');
			viewer = new ImageViewer(container, {
				zoomValue: 100,
				maxZoom: 300,
				snapView: false
			});
			viewer.load( $('.featherlight-image').attr('src') );
			
		}
		
	});
	
});


function fluidVideos() {
	// Resize all videos according to their own aspect ratio
	allVideos.each(function() {
		var $el = $(this);
		var newWidth = $(this).parent().width();
		$el
			.width(newWidth)
			.height(newWidth * $el.data('aspectratio'));
	});
}

function initMap() {
	var element = $('.map_element');
	var the_center;
	var lat = parseFloat(element.data('latitude'));
	var lng = parseFloat(element.data('longitude'));
	var zoom = parseInt(element.data('zoom'));
	var the_center = { lat: lat, lng: lng };
	var map = new google.maps.Map(element[0], {
		zoom: zoom,
		center: the_center,
		scrollwheel: false,
		mapTypeControl: false,
		draggable: true,
		streetViewControl: false,
		zoomControl: true,
		panControl: false,
		mapTypeId: google.maps.MapTypeId.ROADMAP,
	});

	var marker = new google.maps.Marker({
		position: the_center,
		map: map,
		
	});
	google.maps.event.addDomListener(window, 'resize', function() {
		mapcenter(map, the_center);
	});
}
function mapcenter(map, the_center) {
	map.setCenter(new google.maps.LatLng(
		the_center
	));
}




